import { Component, inject } from '@angular/core';
import { PaToggleButtonComponent } from '../../../../shared/ui-kit/pa-toggle-button/pa-toggle-button.component';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { ToggleButtonSeverity } from 'src/app/shared/ui-kit/pa-tag-list/models/pa-tag-list.model';

interface ToggleButtonConfig {
  controlName: string;
  label: string;
  count: number;
  severity?: ToggleButtonSeverity;
}

@Component({
  selector: 'app-toggle-button-view',
  standalone: true,
  imports: [
    PaToggleButtonComponent, 
    FormsModule, 
    ReactiveFormsModule, 
    NgFor,
  ],
  templateUrl: './toggle-button-view.component.html',
  styleUrls: ['./toggle-button-view.component.scss'],
})
export class ToggleButtonViewComponent {
  private fb = inject(FormBuilder);

  form: FormGroup;

  toggleButtons: ToggleButtonConfig[] = [
    { controlName: 'info', label: 'Выключен', count: 1, severity: 'info' },
    { controlName: 'primary', label: 'Основной', count: 5, severity: 'primary' },
    { 
      controlName: 'success', 
      label: 'Успех', 
      count: 10, 
      severity: 'success' 
    },
    { controlName: 'warning', label: 'Предупреждение', count: 3, severity: 'warn' },
    { 
      controlName: 'danger', 
      label: 'Опасность', 
      count: 2, 
      severity: 'danger' 
    },
    { 
      controlName: 'secondary', 
      label: 'Вторичный', 
      count: 8, 
      severity: 'secondary' 
    },
    { 
      controlName: 'secondarySubtle', 
      label: 'Вторичный (subtle)', 
      count: 4, 
      severity: 'secondary-subtle' 
    },
    { 
      controlName: 'secondaryStrong', 
      label: 'Вторичный (strong)', 
      count: 7, 
      severity: 'secondary-strong' 
    },
    { 
      controlName: 'successSubtle', 
      label: 'Успех (subtle)', 
      count: 9, 
      severity: 'success-subtle' 
    },
    { 
      controlName: 'successStrong', 
      label: 'Успех (strong)', 
      count: 12, 
      severity: 'success-strong' 
    },
  ];

  constructor() {
    const formControls: { [key: string]: FormControl } = {};
    
    [...this.toggleButtons].forEach(button => {
      formControls[button.controlName] = new FormControl(false);

      if (button.count === 1) {
        formControls[button.controlName].disable();
      }
    });

    this.form = this.fb.group(formControls);
  }
}